@if (pinService.isActive()) {
    <section
        class="pointer-events-auto absolute bottom-14 right-14 box-border max-h-[calc(100%-4rem)] w-72 max-w-[calc(100%-6rem)] overflow-y-auto rounded-lg bg-white p-3.5 shadow-xl sm:bottom-16 sm:right-20"
        [attr.aria-label]="'pin.title' | transloco">
        <header class="flex items-center justify-between gap-3">
            <h2 class="!m-0 !text-[16px] !font-medium !leading-none !tracking-normal">
                {{ 'pin.title' | transloco }}
            </h2>
        </header>

        @if (pinService.isSelectingPoint()) {
            <p class="my-4 text-center font-medium text-custom-extra-dark-grey">{{ 'pin.selectPoint' | transloco }}</p>
        } @else {
            <div class="my-3.5 flex items-center gap-2">
                <label
                    class="flex min-w-0 flex-1 items-center gap-2 rounded bg-background px-2.5 py-2 text-custom-grey">
                    <fa-icon [icon]="['fas', 'magnifying-glass']" />
                    <input
                        #searchInput
                        class="w-full border-0 bg-transparent outline-none"
                        type="search"
                        [placeholder]="'search' | transloco"
                        (input)="updateSearch(searchInput.value)" />
                </label>
                <app-button
                    class="shrink-0"
                    [customClass]="'!bg-transparent !p-0 !text-custom-blue'"
                    [icon]="['fas', 'bars-sort']"
                    [matMenuTriggerFor]="sortMenu"
                    [tooltip]="'pin.sort' | transloco"
                    [type]="ButtonType.SECONDARY" />
                <mat-menu
                    #sortMenu="matMenu"
                    xPosition="before">
                    <button
                        mat-menu-item
                        type="button"
                        [class.text-custom-blue]="sortOrder() === PinSortOrder.ALPHABETICAL"
                        (click)="updateSortOrder(PinSortOrder.ALPHABETICAL)">
                        {{ 'pin.sortAlphabetically' | transloco }}
                    </button>
                    <button
                        mat-menu-item
                        type="button"
                        [class.text-custom-blue]="sortOrder() === PinSortOrder.MOST_RECENT"
                        (click)="updateSortOrder(PinSortOrder.MOST_RECENT)">
                        {{ 'pin.sortMostRecent' | transloco }}
                    </button>
                </mat-menu>
            </div>

            <ul class="m-0 max-h-64 list-none overflow-y-auto p-0">
                @for (pin of visiblePins(); track pin.id) {
                    <li
                        class="group flex items-center gap-1 rounded-md transition-colors hover:bg-custom-light-blue focus-within:bg-custom-light-blue">
                        <app-button
                            class="block min-w-0 flex-1"
                            [customClass]="'!justify-start !bg-transparent !px-2 !text-black text-left'"
                            [fullWidth]="true"
                            [icon]="['fas', 'location-dot']"
                            [iconColor]="pin.color"
                            [label]="pin.name"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="zoomTo(pin)" />
                        @if (canModify()(pin)) {
                            <app-button
                                [customClass]="'!bg-transparent !p-1 !text-custom-grey'"
                                [icon]="['fas', 'pen']"
                                [tooltip]="'edit' | transloco"
                                [type]="ButtonType.SECONDARY"
                                (onClick)="edit(pin)" />
                            <app-button
                                [customClass]="'!bg-transparent !p-1 !text-custom-red'"
                                [icon]="['fas', 'trash']"
                                [tooltip]="'delete' | transloco"
                                [type]="ButtonType.SECONDARY"
                                (onClick)="confirmDelete(pin)" />
                        }
                    </li>
                } @empty {
                    <li class="my-4 text-center text-custom-grey">{{ 'pin.empty' | transloco }}</li>
                }
            </ul>

            @if (pinService.canManage()) {
                <div class="mt-3.5 flex justify-end">
                    <app-button
                        [disabled]="pinService.isSelectingPoint() || pinService.isCreateModalOpen()"
                        [icon]="['fas', 'plus']"
                        [label]="'create' | transloco"
                        (onClick)="pinService.beginCreate()" />
                </div>
            }
        }
    </section>
}
